import { SubAccountNewLeadsInterface } from '../types/sub-account-interface'

export const getSubAccountNewLeadsStatistics = (
  account: { user: { id: number } },
  newLeads?: SubAccountNewLeadsInterface[],
): SubAccountNewLeadsInterface | null => {
  if (!newLeads) return null

  return newLeads.find(({ user }) => user.id === account.user.id) ?? null
}
